/**
 * 获取验证码
 * @param {*} data 入参
 * @see http://yapi.gacnio-inc.com/project/371/interface/api/27685
 */
import request from "@utils/request";

export function mobileCode(data) {
  return request({
    url: "/hycaner/user/noAuth/front/ssh/mobile/code",
    method: "get",
    params: data,
  });
}
export function mobileLogin(data) {
  return request({
    url: "/hycaner/user/noAuth/front/mobile/login",
    method: "get",
    params: data,
  });
}
export function loginOut(data) {
  return request({
    url: "/hycaner/user/simpleAuth/front/login/out",
    method: "get",
    params: data,
  });
}
//第三方登录   
export function login(data) {
  return request({
    url: "/hycaner/user/noAuth/front/oauth/login",
    method: "get",
    params: data,
  });
}
//用户信息接口
export function userInfo(data) {
  return request({
    url: "/hycaner/user/noAuth/front/info",
    method: "get",
    params: data,
  });
}
//绑定手机号码
export function mobileBind(data) {
  return request({
    url: "/hycaner/user/simpleAuth/front/mobile/bind",
    method: "get",
    params: data,
  });
}
